import React, { FC } from "react";
import dayjs from "dayjs";
import { ParcelStatus } from "@/enums";
import { IShipmentStatus } from "@/types/apiResponse.types";
import { useTranslations } from "next-intl";

type Props = {
  notificationsData: IShipmentStatus[];
};

const NotificationsList: FC<Props> = ({ notificationsData }) => {
  const t = useTranslations();

  const formattedDate = (date: string) => {
    return dayjs(date).format("YYYY-MM-DD");
  };

  return (
    <ul className="h-[300px] w-full overflow-y-auto px-5">
      {notificationsData.map((notification, index) => (
        <li key={index} className="border-b border-[#f5f5f5] py-4">
          <span className="text-xs text-[#909ba6]">
            {(notification.satus_date &&
              formattedDate(notification.satus_date)) ||
              ""}
          </span>
          <h4 className="text-wrap text-sm font-medium">
            {(notification?.status_name && t(notification?.status_name)) || ""}
          </h4>
          <p className="text-xs font-normal text-[#888888]">
            {notification?.track_code || ""}
          </p>
        </li>
      ))}
    </ul>
  );
};

export default NotificationsList;
